<template>
  <el-form class="ldap-login" ref="loginForm" :model="info" :rules="loginRules" auto-complete="on" label-position="left">
    <el-form-item prop="username">
      <span class="svg-container svg-container_login">
        <svg-icon icon-class="username" style="margin-left:-3px"/>
      </span>
      <el-input 
        v-model="info.username"
        autofocus 
        name="username" 
        type="text" 
        auto-complete="off" 
        :placeholder="$t('login.username')" 
        @keyup.enter.native="handleLogin" />
    </el-form-item>
    <el-form-item prop="password">
      <span class="svg-container">
        <svg-icon icon-class="password"/>
      </span>
      <el-input
        type="password"
        v-model="info.password"
        name="password"
        auto-complete="on"
        :placeholder="$t('login.password')"
        @keyup.enter.native="handleLogin"/>
      <!-- <span class="show-pwd" @click="showPwd">
        <svg-icon v-if="pwdType === 'password'" icon-class="eye"/>
        <svg-icon v-else icon-class="open_eye"/>
      </span> -->
    </el-form-item>         
    <el-form-item style="border:none">
      <el-button v-waves :loading="loading" type="primary" size="big" style="width:100%;" @click.native.prevent="handleLogin">
        {{$t('login.logIn')}}
      </el-button>
    </el-form-item> 
  </el-form>
</template>
<script>
import {getSolutionId} from '@/utils/auth'
export default {
  name: 'ldapLogin',
  data() {
    return {
      loading: false,
      loginRules: {
        username: [
          { required: true, trigger: ['blur', 'change'], message: this.$t('login.usernameRequired') }
        ],
        password: [{ required: true, trigger: ['blur', 'change'], message: this.$t('login.passwordRequired') }]
      },
      info: {
        username: '',
        password: '',
        type: 'ldap',
        state: '',
        code: '',
        sid: getSolutionId()
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('thirdPartyLogin', this.info).then(() => {
            this.loading = false
            this.$store.dispatch('delAllViews')
            localStorage.removeItem('lastTab')
            this.$router.push('/')
          })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.ldap-login{
  position: relative;
  z-index: 99;
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #C0C4CC;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
}
</style>